import { useTableI18nProps } from '../hooks/useTableI18nProps';

export function createTableWithI18n(OrigTable) {
  function TableWithI18n(props) {
    const tableI18nProps = useTableI18nProps();
    return <OrigTable {...tableI18nProps} {...props} />;
  }
  TableWithI18n.displayName = 'TableWithI18n';
  return TableWithI18n;
}
